require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

import "swiper/css/bundle";

(function ($) {
    if ($(".multi-step-form").length > 0) {
        require("./custom/multi-step-form.es6");
    }

    if ($(".vertical_photo_carousel").length > 0) {
        require("./custom/photo-carousel.es6");
    }

})(jQuery);